"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabletTrayMenu = void 0;
const classnames_1 = __importDefault(require("classnames"));
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../shared");
const utils_1 = require("../../utils");
const atoms_1 = require("../atoms");
const enhanced_1 = require("../enhanced");
const BackTrayItem_1 = require("./BackTrayItem");
const MobileLinks_1 = require("./MobileLinks");
const TrayItem_1 = require("./TrayItem");
const Styled = styled_components_1.default.div `
	border-bottom: 1px solid ${(p) => p.theme.palette.border};
	&:last-child {
		border-bottom: none;
	}
`;
const TabletTrayMenu = ({ link = {}, parentMenuOpen, trayId, locale }) => {
    const { menuOpen, setMenuOpen } = (0, shared_1.useActiveInnerMobileTray)(trayId);
    const [trayContentHeight, setTrayContentHeight] = (0, react_1.useState)(200);
    const toggleMenu = (0, shared_1.useToggleMenu)(menuOpen, setMenuOpen, "");
    const onKeyUp = (0, shared_1.useHandleKeyUp)(toggleMenu, toggleMenu);
    const isEnhancedDropdown = (0, utils_1.isValidEnhancedDropdown)(link);
    const enhanced = link.enhancedDropdown || {};
    const { describeColumn = {}, externalColumn = {} } = enhanced;
    const kids = link.kids || [];
    const hasKids = Boolean(kids.length);
    let customMainLinks;
    if (enhanced && enhanced.mainLinksNode) {
        customMainLinks = react_1.default.cloneElement(react_1.default.createElement(react_1.default.Fragment, null, enhanced.mainLinksNode), { links: kids, locale });
    }
    let customExternalColumn;
    if (externalColumn && externalColumn.externalColumnNode) {
        customExternalColumn = react_1.default.cloneElement(react_1.default.createElement(react_1.default.Fragment, null, externalColumn.externalColumnNode), Object.assign(Object.assign({}, externalColumn), { locale }));
    }
    const validCustomNodes = Boolean(customMainLinks || customExternalColumn);
    const validInnerMenu = hasKids || validCustomNodes;
    const trayContentRef = (0, react_1.useRef)(null);
    (0, shared_1.useBoundingClientRect)(trayContentRef, ({ height }) => {
        if (height !== trayContentHeight) {
            setTrayContentHeight(height);
        }
    });
    const menuClasses = (0, classnames_1.default)("tray-menu-item", { dropdown: parentMenuOpen && menuOpen });
    return (react_1.default.createElement(Styled, { className: menuClasses, onKeyUp: onKeyUp, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick },
        react_1.default.createElement(TrayItem_1.TrayItem, { isMenuToggle: validInnerMenu, toggleMenu: !menuOpen ? toggleMenu : undefined, role: "menuitem", tabIndex: menuOpen ? -1 : 0, className: menuClasses, onKeyUp: onKeyUp, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, link: link, locale: locale },
            react_1.default.createElement("div", { className: "tray-item-inner" },
                react_1.default.createElement("span", { className: "tray-item-title" }, link.title),
                validInnerMenu ? react_1.default.createElement(atoms_1.ArrowIcon, null) : ""),
            react_1.default.createElement(TrayItem_1.TrayContent, { ref: trayContentRef, className: "tray-content", menuOpen: menuOpen },
                react_1.default.createElement(BackTrayItem_1.BackTrayItem, { toggleMenu: toggleMenu, menuOpen: menuOpen }),
                isEnhancedDropdown ? (react_1.default.createElement(enhanced_1.EnhancedDropdownLayout, { extraClassnames: "tablet", menuOpen: menuOpen, thin: true, minHeight: trayContentHeight },
                    react_1.default.createElement(enhanced_1.DescribeColumn, Object.assign({}, describeColumn, { locale: locale })),
                    customMainLinks || react_1.default.createElement(enhanced_1.MainLinks, { links: kids, locale: locale }),
                    customExternalColumn || react_1.default.createElement(enhanced_1.ExternalColumn, Object.assign({}, externalColumn, { locale: locale })))) : (react_1.default.createElement(MobileLinks_1.MobileLinks, { menuOpen: menuOpen, links: kids, tablet: true, minHeight: trayContentHeight, locale: locale }))))));
};
exports.TabletTrayMenu = TabletTrayMenu;
//# sourceMappingURL=TabletTrayMenu.js.map